"use client";

import {Button, Form, InputGroup, OverlayTrigger, Tooltip} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {FaMinus, FaPlus} from "react-icons/fa";
import styles from "../../Cart/CartForm/cart.module.scss";

export interface QuantityInputProps {
    formik: any;
    field: string;
    inputValue: number;
    minValue: number;
    quantityUpdateCallBack: any;
}

export const QuantityInput = ({ formik, field, inputValue, quantityUpdateCallBack, minValue }: QuantityInputProps) => {
    const [quantity, setQuantity] = useState(minValue);

    const increment = (idProduct: string) => {
        setQuantity((prevQuantity) => prevQuantity + 1);
        quantityUpdateCallBack(quantity + 1, idProduct);
    };

    const decrement = (idProduct: string) => {
        if (quantity > minValue) {
            setQuantity((prevQuantity) => (prevQuantity > minValue ? prevQuantity - 1 : prevQuantity));
            quantityUpdateCallBack(quantity - 1, idProduct);
        }
    };

    const changeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(event.target.value, 10);
        if (Number.isFinite(value) && value >= minValue) {
            updateProductQuantity(event);
            setQuantity(value);
        }
    };

    const updateProductQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedQuantity = parseInt(event.target.value, 10);
        const idProduct = event.target.id.split("-")[1];

        quantityUpdateCallBack(updatedQuantity, idProduct);
    };

    useEffect(() => {
        if (inputValue) {
            setQuantity(inputValue);
        }
    }, [inputValue]);

    return (
        <div className={styles.actionWrapper}>
            <InputGroup className={styles.inputGroup}>
                {minValue > 1 ? (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Cantitatea minima pentru comanda este <strong>{minValue} buc</strong>
                            </Tooltip>
                        }
                    >
                        <Button
                            size="sm"
                            className={styles.decrement}
                            variant="outline-secondary"
                            onClick={() => decrement(field.split("-")[1])}
                            disabled={quantity === minValue}
                        >
                            <FaMinus />
                        </Button>
                    </OverlayTrigger>
                ) : (
                    <Button
                        size="sm"
                        className={styles.decrement}
                        variant="outline-secondary"
                        onClick={() => decrement(field.split("-")[1])}
                        disabled={quantity === minValue}
                    >
                        <FaMinus />
                    </Button>
                )}

                <Form.Control
                    className="text-center"
                    type="number"
                    id={field}
                    name={field}
                    value={quantity}
                    onBlur={formik.handleBlur}
                    onChange={changeInput}
                    min={minValue}
                />
                {formik.touched[field] && formik.errors[field] ? <div className="text-danger">{formik.errors[field]}</div> : null}
                <Button
                    size="sm"
                    className={styles.increment}
                    variant="outline-secondary"
                    onClick={() => increment(field.split("-")[1])}
                >
                    <FaPlus />
                </Button>
            </InputGroup>
        </div>
    );
};
